import { SubscriptionPlanBackend } from "api/subscription";
import { sortBy, map } from "underscore";

export interface SubscriptionPlanViewModel {
	systemName: string;
	isBasePlan: boolean;
	priceWithDiscount: number;
	priceWithoutDiscount: number;
	discountPercent: number;
	pricePerMonth: number;
	period: string;
}

export function createPlansViewModels(plans: SubscriptionPlanBackend[]): SubscriptionPlanViewModel[] {
	const orderedPlans = sortBy(plans, x => x.monthCount);
	const basePlan = orderedPlans[0];
	const [, ...otherPlans] = orderedPlans;

	const basePlanViewModel = createBasePlanViewModel(basePlan);
	const otherPlanViewModels: SubscriptionPlanViewModel[] = map(otherPlans, plan => createOtherPlanViewModel(plan, basePlan));

	return [basePlanViewModel, ...otherPlanViewModels];
}

function createBasePlanViewModel(plan: SubscriptionPlanBackend): SubscriptionPlanViewModel {
	return {
		isBasePlan: true,
		systemName: plan.systemName,
		discountPercent: 0,
		priceWithDiscount: plan.price,
		priceWithoutDiscount: plan.price,
		period: mapPeriod(plan.monthCount),
		pricePerMonth: plan.price
	};
}
function createOtherPlanViewModel(plan: SubscriptionPlanBackend, basePlan: SubscriptionPlanBackend): SubscriptionPlanViewModel {
	const priceWithoutDiscount = basePlan.price * plan.monthCount / basePlan.monthCount;
	return {
		isBasePlan: false,
		systemName: plan.systemName,
		discountPercent: ((priceWithoutDiscount - plan.price) / priceWithoutDiscount * 100),
		priceWithDiscount: plan.price,
		priceWithoutDiscount: priceWithoutDiscount,
		period: mapPeriod(plan.monthCount),
		pricePerMonth: plan.price / plan.monthCount
	};
}
function mapPeriod(monthCount: number): string {
	switch (monthCount) {
		case 1:
			return '1 месяц';
		case 2:
		case 3:
		case 4:
			return `${monthCount} месяца`;
		default:
			return `${monthCount} месяцев`;
	}
}